import { useSearchParams } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';
import { MODAL_QUERY_KEY, Modals } from '@/helpers/modals';
import { useModalsStore } from '@/store';
import { useGetCommonStore } from '@/store/commonStore';

const DEFAULT_TIMER = 7000;

export function useTimeoutRegistrationModal(timer = DEFAULT_TIMER) {
  const useCommonStore = useGetCommonStore();

  const [isRegShown, setIsRegShown] = useState(false);
  const searchParams = useSearchParams();

  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const pendingUser = useCommonStore.use.pendingUser();

  const open = useModalsStore.use.open();

  const isAnyModalOpened = useMemo(
    () => searchParams.has(MODAL_QUERY_KEY),
    [searchParams]
  );

  useEffect(() => {
    if (isAuthenticated || pendingUser || isAnyModalOpened || isRegShown)
      return;

    const timeoutId = setTimeout(() => {
      open(Modals.Registration);
      setIsRegShown(true);
    }, timer);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isAuthenticated, open, pendingUser, timer, isAnyModalOpened, isRegShown]);
}
